// Shared provider-dropdown option builders that were duplicated (token-identical)
// between components/ModelManagement.vue and views/Flow.vue.
// Both methods rely on sibling methods that intentionally stay per-file
// (normalizeLookupValue, getFixedProviderByPlatform, matchesProvider) — Vue resolves
// this.* against the component, so each file keeps its own local variants.
export default {
  methods: {
    getAllProviderOptions() {
      const providerMap = new Map();

      const registerProvider = (providerName, source = {}) => {
        const normalizedProviderName = this.normalizeLookupValue(providerName);
        if (!normalizedProviderName) {
          return;
        }

        if (!providerMap.has(normalizedProviderName)) {
          providerMap.set(normalizedProviderName, {
            ...source,
            providerName: typeof providerName === 'string' ? providerName.trim() : providerName,
          });
        }
      };

      if (Array.isArray(this.listDDProvider)) {
        this.listDDProvider.forEach((provider) => {
          registerProvider(provider?.providerName ?? provider?.provider, provider);
        });
      }

      if (Array.isArray(this.listDDModel)) {
        this.listDDModel.forEach((model) => {
          registerProvider(model?.provider, { providerName: model?.provider });
        });
      }

      return Array.from(providerMap.values());
    },
    getProviderOptionsForPlatform(platform) {
      const allProviderOptions = this.getAllProviderOptions();
      const fixedProvider = this.getFixedProviderByPlatform(platform);

      if (fixedProvider) {
        const fixedProviderOptions = allProviderOptions.filter((provider) => this.matchesProvider(provider.providerName, fixedProvider));
        return fixedProviderOptions.length > 0 ? fixedProviderOptions : [{ providerName: fixedProvider }];
      }

      if (this.normalizeLookupValue(platform) === 'azure') {
        return allProviderOptions.filter((provider) => {
          const providerName = this.normalizeLookupValue(provider.providerName);
          return providerName !== 'google' && providerName !== 'other';
        });
      }

      return allProviderOptions;
    },
  },
};
